import { useState } from "react"
import { AiOutlineCloseCircle, AiOutlineWhatsApp } from "react-icons/ai"
import { FaPhoneAlt } from "react-icons/fa"
import { useSelector } from "react-redux"

const FloatingWhatsapp = ({
  whatsapps
}) => {

  const {
    screenSize
  } = useSelector(state => state.global)

  const [isOpen, setIsOpen] = useState(true)

  return (
    <>
    {isOpen && (
      <div 
        className="fixed bottom-[170px] rounded-lg bg-white space-y-1 z-10 shadow-lg"
        style={{
          width: '250px',
          right: screenSize.width > 1900 ? '20%' : '5%'
        }}
      >
        <div 
          className="flex items-center justify-between bg-green-500 text-white rounded-tl-lg rounded-tr-lg p-1.5 font-bold" 
          style={{ 
            fontSize: '12px' 
          }}
        >
          <label>Kontak kami via Whatsapp</label>
          <button
            title="tutup"
            onClick={() => setIsOpen(false)}
          >
            <AiOutlineCloseCircle className="h-5 w-5"/>
          </button>
        </div>
        <div
          className="p-2 divide-y divide-gray-200"
        >
          {whatsapps.map(wa => (
            <div
              className="bg-white p-2 rounded-lg text-left flex items-center space-x-3"
              style={{
                fontSize: '14px'
              }}
            >
              <div
                className="bg-green-500 text-white p-2 rounded-full"
              >
                <FaPhoneAlt className="h-5 w-5"/>
              </div>
              <div
              >
                <div>{wa.label}</div>
                <div>{wa.value}</div>
                <div className="py-2">
                  <button
                    className="p-1.5 px-3 bg-green-600 text-white rounded-md"
                    style={{
                      fontSize: '13px'
                    }}
                    onClick={() => window.open('https://wa.me/' + wa.value, '_blank')}
                  >
                    Chat Sekarang
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}
    <div
      className="fixed bottom-[50px] p-3 z-[10]"
      style={{
        right: screenSize.width > 1900 ? '20%' : '5%'
      }}
    >
      <button
        className="p-2 bg-green-600 hover:bg-green-400 rounded-full mb-10 flex items-center justify-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        <AiOutlineWhatsApp className="h-10 w-10 text-white"/>
      </button>
    </div>
    </>
  )

}

export default FloatingWhatsapp